/**
 * 首页标题3
 */

import { Row, Col } from 'antd';

const HH3 = () => {
    return <>
        <div style={{ backgroundColor: 'rgba(0,0,0,0)', color: '#fff' }}>
            <Row>
                <Col offset={4} span={16} style={{ textAlign: 'center' }}>
                    <h1>关于我们</h1>
                    <p>为客户提供创新的信息化技术服务支撑解决方案，使用户专注于服务价值。</p>
                </Col>
                <Col offset={4} span={6} style={{ marginTop: '50px' }}>
                    <p>湖南新致腾信息科技有限公司，是一家为客户提供创新的信息化技术服务支撑解决方案，使用户专注于服务价值的信息化行业技术服务支撑品牌提供商。</p>
                    <p><strong>公司理念：</strong>同心致远，聚力腾飞。</p>
                    <p><strong>公司宗旨：</strong>服务专业化、服务标准化、服务品牌化，高效解决用户遇到的问题，给用户提供创新的信息化技术服务支撑，让用户无后顾之忧。</p>
                    <p><strong>公司团队：</strong>创始团队在信息化服务行业扎根十多年，拥有丰富的经验、成功的案例和良好的口碑，技术扎实，管理娴熟，对实现服务专业化、标准化、品牌化有科学成熟的解决方案。</p>
                    <p><strong>管理思想：</strong>同心致远，聚力腾飞。以结果为导向，以科技为手段，同心聚力，汇集精英。以人才为核心，注重团队合作。风险共担，利益共享。</p>
                </Col>
            </Row>
        </div>
    </>
}

export default HH3;